import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'router-fragment',
  templateUrl: './fragment.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FragmentComponent implements OnInit, OnChanges {
  @Input() fragment: string;

  @Input() active: string;

  @HostBinding('style.display') display = 'inherit';

  ngOnInit(): void {
    this.setDisplay();
  }

  ngOnChanges(): void {
    this.setDisplay();
  }

  private setDisplay() {
    this.display = this.fragment === this.active ? 'inherit' : 'none';
  }
}
